import React from 'react'
import img_05 from '../../images/vi-img-05.png'
import img_06 from '../../images/vi-img-06.png'
import img_07 from '../../images/vi-img-07.png'
import img_08 from '../../images/vi-img-09.png'
export default function HomeSlider() {
    return (
        <div>
            <div id="carouselExampleIndicators" className="carousel main-car slide" data-bs-ride="carousel">
                <div className="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
                </div>
                <div className="carousel-inner">
                    <div className="carousel-item">
                        <div className='row'>
                            <div className='col-md-4 mb-24 order-md-2'>
                                <img src={img_05} className='img-fluid' alt='businesses' />
                            </div>
                            <div className='col-md-8 mb-24'>
                                <div className='badge badge-primary'>People who trust us</div>
                                <h4>Local businesses thriving <br/> through fast & reliable deliveries</h4>
                                <p>From small town sellers to fast-scaling D2C brands, we ensure your orders reach customers quickly, safely, and with complete visibility at every step. Boost customer satisfaction, reduce RTO, and scale your brand with dependable deliveries designed for modern D2C and local businesses.</p>
                            </div>
                        </div> 
                        <div className='row'>
                            <div className='col-md-4 mb-48'>
                                <div className='slider-box'>
                                    <h4>18%</h4>
                                    <p>Increase in checkout-to-delivery success rate</p>
                                </div>
                            </div>
                            <div className='col-md-4 mb-48'>
                                <div className='slider-box slider-box-item01'>
                                    <h4>20%</h4>
                                    <p>reduction in overall shipping cost</p>
                                </div>
                            </div>
                            <div className='col-md-4 mb-48'>
                                <div className='slider-box slider-box-item02'>
                                    <h4>25%</h4>
                                    <p>lower RTO with COD + address verification</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="carousel-item active">
                        <div className='row'>
                            <div className='col-md-4 order-md-2 mb-24'>
                                <img src={img_07} className='img-fluid' alt='businesses' />
                            </div>
                            <div className='col-md-8 mb-24'>
                                <div className='badge badge-primary'>People who trust us</div>
                                <h4>Small Instagram Stores Turning Passion <br/ > into Profitable Businesses</h4>
                                <p>From home-based creators to fast-growing Instagram sellers, ParcelX helps social commerce businesses deliver across India without worrying about logistics. Manage orders from a single dashboard, choose from multiple courier partners, and give your customers a reliable delivery experience. With smarter shipping tools and transparent tracking, sellers can focus on growing their brand while ParcelX handles the logistics.</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-4 mb-48'>
                                <div className='slider-box'>
                                    <h4>18%</h4>
                                    <p>higher order delivery success</p>
                                </div>
                            </div>
                            <div className='col-md-4 mb-48'>
                                <div className='slider-box slider-box-item01'>
                                    <h4>20%</h4>
                                    <p>reduction in overall shipping cost</p>
                                </div>
                            </div>
                            <div className='col-md-4 mb-48'>
                                <div className='slider-box slider-box-item02'>
                                    <h4>25%</h4>
                                    <p>lower RTO with COD + address verification</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="carousel-item">
                        <div className='row'>
                            <div className='col-md-4 order-md-2 mb-24'>
                                <img src={img_06} className='img-fluid' alt='businesses' />
                            </div>
                            <div className='col-md-8 mb-24'>
                                <div className='badge badge-primary'>People who trust us</div>
                                <h4><div className='d-sm-block d-none'>Fast-Growing D2C Brands Scaling Their <br /> Deliveries with ParcelX</div><div className='d-sm-none d-block'>Fast-Growing D2C Brands Scaling Their Deliveries with ParcelX</div></h4>
                                <p>Modern D2C brands need logistics that move as fast as their growth. ParcelX provides a unified shipping platform that simplifies order fulfilment, courier selection, and tracking. With automated processes, optimized courier allocation, and real-time visibility, brands can deliver faster, reduce operational complexity, and create a seamless post-purchase experience for customers.</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-4 mb-48'>
                                <div className='slider-box'>
                                    <h4>25%</h4>
                                    <p>faster order dispatch</p>
                                </div>
                            </div>
                            <div className='col-md-4 mb-48'>
                                <div className='slider-box slider-box-item01'>
                                    <h4>20%</h4>
                                    <p>lower overall logistics cost</p>
                                </div>
                            </div>
                            <div className='col-md-4 mb-48'>
                                <div className='slider-box slider-box-item02'>
                                    <h4>25%</h4>
                                    <p>improvement in delivery success rates</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="carousel-item">
                        <div className='row'>
                            <div className='col-md-4 order-md-2 mb-24'>
                                <img src={img_08} className='img-fluid' alt='businesses' />
                            </div>
                            <div className='col-md-8 mb-24'>
                                <div className='badge badge-primary'>People who trust us</div>
                                <h4>Manufacturers Delivering <br /> Products Efficiently Across India</h4>
                                <p>Manufacturers and bulk sellers rely on ParcelX to simplify large-scale shipping operations and streamline their distribution logistics. Whether delivering products to retailers, distributors, warehouses, or directly to customers, ParcelX provides access to multiple courier partners through a single, easy-to-use platform. Businesses can compare shipping options, select the most efficient delivery partner, and optimize logistics costs while maintaining complete visibility of every shipment.</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-4 mb-48'>
                                <div className='slider-box'>
                                    <h4>30%</h4>
                                    <p>faster shipping operations</p>
                                </div>
                            </div>
                            <div className='col-md-4 mb-48'>
                                <div className='slider-box slider-box-item01'>
                                    <h4>20%</h4>
                                    <p>savings on logistics costs</p>
                                </div>
                            </div>
                            <div className='col-md-4 mb-48'>
                                <div className='slider-box slider-box-item02'>
                                    <h4>29K</h4>
                                    <p>pincodes for nationwide delivery coverage</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='position-relative'>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
            </div>
        </div>
    )
}
